import PropTypes from "prop-types";

import { useDeviceInfo } from "@swa-ui/browser";

/**
 * SuppressForIframe suppresses its children from rendering when in an iframe.
 */

export const SuppressForIframe = (props) => {
  const { children } = props;
  const { isInIframe } = useDeviceInfo();

  return isInIframe ? null : children;
};

SuppressForIframe.propTypes = {
  /** The content to render when not in an iframe. */
  children: PropTypes.node.isRequired,
};
